import { Text } from 'foundations-components/components/Text';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { NavMarker } from 'react-rhumb';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { View } from 'foundations-components/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LearningContentCard } from '../../cards/components/LearningContentCard';
import { useAnnouncements } from '../hooks/AnnouncementsSectionHooks';
import HomePageSection from '../../../components/Layouts/HomePageSection';
import { HasGate } from '../../accounts/components/HasGate';
import { useHasGate } from '../../accounts/accountsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isHubSpotAcademyUrl = url => {
  if (url.startsWith('/')) {
    return true;
  }
  return /^https?:\/\/(app|local)(-[a-z0-9]+)?\.hubspot(qa)?\.com\/academy/.test(url);
};
const getInternalPath = url => {
  if (url.startsWith('/')) {
    return url;
  }
  const academyUrlMatch = url.match(/^https?:\/\/(app|local)(-[a-z0-9]+)?\.hubspot(qa)?\.com\/academy\/[^/]+(.*)$/);
  if (academyUrlMatch) {
    return academyUrlMatch[4] || '/';
  }
  return url;
};
export const AnnouncementsSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    announcements,
    error,
    featuredCardModel,
    loading,
    cardModelsError
  } = useAnnouncements();
  const {
    hasGate: isUngatedForUnifiedAcademyNavigation
  } = useHasGate('Academy:UnifiedAcademy:Navigation');
  if (error) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "HOMEPAGE_ANNOUNCEMENTS_ERROR"
    });
  }
  if (!announcements || !announcements.length) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "HOMEPAGE_ANNOUNCEMENTS_LOADED"
    });
  }
  if (cardModelsError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "HOMEPAGE_ANNOUNCEMENTS_ERROR"
    });
  }
  const featuredAnnouncement = announcements[0];
  const content = /*#__PURE__*/_jsx(CardWrapper, Object.assign({
    borderRadius: "300",
    "data-test-id": "announcements-section"
  }, isUngatedForUnifiedAcademyNavigation ? {
    marginBlockEnd: '0'
  } : {
    marginBlockEnd: '1100',
    marginBlockStart: '800'
  }, {
    padding: isMobile ? '600' : '1000',
    paddingBlock: isMobile ? '500' : '1000',
    children: /*#__PURE__*/_jsxs(CardGrid, {
      alignItems: "start",
      gap: "900",
      gridTemplateColumns: isMobile ? '1fr' : '9fr 3fr',
      children: [/*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          marginBlockEnd: "200",
          typography: "heading-300",
          children: featuredAnnouncement.title
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "600",
          typography: "body-200",
          children: featuredAnnouncement.body
        }), featuredAnnouncement.ctaUrl && /*#__PURE__*/_jsx(_Fragment, {
          children: isHubSpotAcademyUrl(featuredAnnouncement.ctaUrl) ? /*#__PURE__*/_jsx(RouterButton, {
            onClick: () => {
              // TO-DO: Add event tracking for CTA
            },
            to: getInternalPath(featuredAnnouncement.ctaUrl || '#'),
            use: "secondary",
            children: featuredAnnouncement.ctaText || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.announcements.seeMore"
            })
          }) : /*#__PURE__*/_jsx(Button, {
            external: true,
            href: featuredAnnouncement.ctaUrl || '#',
            use: "secondary",
            children: featuredAnnouncement.ctaText || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.announcements.seeMore"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(View, {
        children: loading ? /*#__PURE__*/_jsx(View, {
          backgroundColor: "fill-field-default",
          blockSize: isMobile ? '200px' : '300px',
          borderRadius: "300",
          inlineSize: "100%"
        }) : featuredCardModel ? /*#__PURE__*/_jsx(LearningContentCard, {
          item: featuredCardModel,
          size: isMobile ? 'small' : 'large'
        }) : /*#__PURE__*/_jsx(Image, {
          alt: I18n.text('learningCenter.announcements.altText'),
          blockSize: "auto",
          inlineSize: "100%",
          objectFit: "contain",
          src: featuredAnnouncement.banner || ''
        })
      })]
    })
  }));
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "HOMEPAGE_ANNOUNCEMENTS_LOADED",
    children: /*#__PURE__*/_jsx(HasGate, {
      fallback: content,
      gate: "Academy:UnifiedAcademy:Navigation",
      children: /*#__PURE__*/_jsx(HomePageSection, {
        paddingBlock: "0",
        children: content
      })
    })
  });
};
export default AnnouncementsSection;